module.exports = __webpack_public_path__ + "static/img/Logo4_RDTours.7244469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo4_RDTours.png
// module id = 317
// module chunks = 2